// Module
var code = "<div class=\"fpd-loader-wrapper\"> <div class=\"fpd-loader\"> <div class=\"fpd-loader-circle\"></div> <span class=\"fpd-loader-text\" data-defaulttext=\"Initializing Product Designer\">misc.initializing</span> </div> </div>";
// Exports
module.exports = code;